"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:jsx-wrap-multiline
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const react_1 = require("react");
class Input extends react_1.Component {
    constructor(props) {
        super(props);
        if (props.type === 'password') {
            this.state = {
                show: false,
            };
        }
        this.toggleShow = this.toggleShow.bind(this);
    }
    render() {
        const _a = this.props, { className, type, helperText, errorMessage, showText, hideText, strengthClass, appendText, showNumberArrows } = _a, attributes = __rest(_a, ["className", "type", "helperText", "errorMessage", "showText", "hideText", "strengthClass", "appendText", "showNumberArrows"]);
        const inputClasses = classnames_1.default({
            'form-control': type !== 'checkbox',
            'remove-arrow-number-input': type === 'number' && !showNumberArrows,
            'styled-checkbox': type === 'checkbox',
            [`number-input`]: type === 'number',
            [className]: !!className,
        });
        let inputType = type;
        if (type === 'password' && this.state.show) {
            inputType = 'text';
        }
        let strengthIndicatorClasses;
        if (type === 'password') {
            strengthIndicatorClasses = classnames_1.default({
                'password-progress': true,
                [strengthClass]: !!strengthClass,
            });
        }
        return (React.createElement(react_1.Fragment, null,
            appendText && (React.createElement("div", { className: "append-text-container" },
                React.createElement("input", Object.assign({}, attributes, { type: inputType, className: inputClasses })),
                React.createElement("span", { className: "append-text" }, appendText))),
            !appendText && (React.createElement("input", Object.assign({}, attributes, { type: inputType, className: inputClasses }))),
            type === 'password' && (React.createElement("span", { className: "show-pw", onClick: this.toggleShow }, this.state.show ? hideText : showText)),
            type === 'password' && (React.createElement("div", { className: strengthIndicatorClasses })),
            helperText && (React.createElement("div", { className: "form-helper" }, helperText)),
            errorMessage && (React.createElement("div", { className: "form-message message-error" }, errorMessage))));
    }
    toggleShow() {
        this.setState((prevState) => ({
            show: !prevState.show,
        }));
    }
}
Input.defaultProps = {
    hideText: 'Hide',
    showNumberArrows: false,
    showText: 'Show',
    type: 'text',
};
exports.default = Input;
//# sourceMappingURL=Input.js.map